import { MarketDataProvider } from './context/MarketDataContext';
import { EditorModeProvider } from './context/EditorModeContext';
import { AppShell } from './components/Layout/AppShell';
import { PrintView } from './components/Print/PrintView';

import './styles/tokens/primitives.css';
import './styles/tokens/semantic.css';
import './styles/tokens/components.css';
import './styles/reset.css';
import './styles/typography.css';
import './styles/print.css';
import './App.css';

export function App() {
  return (
    <MarketDataProvider>
      <EditorModeProvider>
        <AppShell>
          <PrintView />
        </AppShell>
      </EditorModeProvider>
    </MarketDataProvider>
  );
}
